package pl.mothdigital.neuronowi.components.text

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

val H1Style = TextBaseStyle.extendedBy {
    base {
        Modifier
            .fontSize(36.px)
            .lineHeight(48.px)
            .fontWeight(FontWeight.Bold)
            .margin(topBottom = 0.px)
    }
    until(Breakpoint.LG) {
        Modifier
            .fontSize(32.px)
            .lineHeight(44.px)
    }
    until(Breakpoint.MD) {
        Modifier
            .fontSize(28.px)
            .lineHeight(40.px)
    }
    until(Breakpoint.SM) {
        Modifier
            .fontSize(24.px)
            .lineHeight(36.px)
    }
}

@Composable
fun AppH1(
    modifier: Modifier = Modifier,
    color: Color = SiteTheme.green._900,
    content: @Composable () -> Unit = {},
) {
    H1(H1Style.toModifier().color(color).then(modifier).toAttrs()) { content() }
}
